import React, { useState, useEffect, useContext } from 'react'
import DynamicContext from '../../context/dynamic/dynamicContext'
import ProductCommonContext from '../../context/common/commonContext'

const InitialPrivateFunction = (props) => {
    const { getMainDashboardData } = useContext(ProductCommonContext)

    const {
        getAllDynamicFields,
        getAllDynamicTables,
        getAllDynamicPagesFields,
    } = useContext(DynamicContext)

    useEffect(() => {
        if (props.fields) {
            getAllDynamicFields({
                page: 1,
                limit: 1000,
                order: 'asc',
                orderby: 'df.show_order',
                table: 'dynamic_fields',
                filters: {},
            })
        }
        if (props.tables) {
            getAllDynamicTables({
                page: 1,
                limit: 1000,
                order: 'asc',
                orderby: 'dt.show_order',
                table: 'dynamic_tables',
                filters: {},
            })
        }
        if (props.pageFields) {
            getAllDynamicPagesFields({
                page: 1,
                limit: 1000,
                order: 'asc',
                orderby: 'dvpi.id',
                primaryTable: 'dynamic_view_page_info',
                filters: {},
            })
        }
        if (props.dashboard) {
            getMainDashboardData()
        }
    }, [])
    return <></>
}

export default InitialPrivateFunction
